

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import PortletLabel from 'components/PortletLabel';
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import CircularProgress from '@material-ui/core/CircularProgress';
//import {HarFileView} from 'react-perfcascade';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { Grid, TableRow, TableCell, Divider, Table } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
//import harData from './example.har';
import {getAudioPatternList} from '../../../../../services/getAudioPatternList'
import Audio from '../../../../../helpers/Audio';
import icons from '../../../../../theme/icons-semaforo.js';
// Component styles

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))



class AudioPatternElement extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isLoad:true,
            objective:this.props.objective,
            nodes:this.props.nodes,
            steps:this.props.steps,
            begin:this.props.dateBegin,
            final:this.props.dateFinal,
            dates:null,
            modalOpen:false,
            onClose:this.props.onClose
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dateBegin !== state.begin||props.dateFinal!==state.final) {
            return {
                isLoad:true,
                begin:props.dateBegin,
                final:props.dateFinal,
                dates:null
            }
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.dateBegin!== this.state.begin||prevProps.dateFinal!== this.state.final){
            this.processData();
        }
    }

    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, begin, final, token) =>{         
        var getData = getAudioPatternList(objective, begin, final, token)           
        getData.then( data =>  { 
            this.setState({
                isLoad:false,
                data:data
            })
        })      
        
    }
   
    processData = () => {
        const { objective, begin, final} = this.state
        let token = sessionStorage.getItem('key')
        this.getFetchs(objective, begin, final, token)
    }

    dataElements=(step, stepName, data)=>{
        const {classes} = this.props
        var dataReturn = []
        if (data.status != 3) {
            data.map(pattern=>{
                if (step == pattern.paso_orden) {
                    pattern['paso_nombre'] = stepName
                    dataReturn.push( <TableRow><Button color="primary" size="small" style={{backgroundColor: 'white', width:"100%"}} onClick={(e)=>{this.setOpen(pattern)}}>{pattern.patron}</Button></TableRow>)
                }
            })
        } else {
            dataReturn.push( <Typography>No se encuentra audio</Typography>)
        }
        return dataReturn
    }
    setOpen = (audio) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            setAudio : audio,
        })
    }
    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true,
            setAudio : null
        })
    }


    render() {

        const { isLoad, data, steps, objective, modalOpen, onClose} = this.state;
        const { classes } = this.props;
          
        return(<Portlet >
                    <PortletHeader style={{backgroundColor:'#525252', color:'white'}}>
                        <Typography 
                            variant="h3"
                            //title="Detalle Patrones"                                        
                        >Detalle Patrones</Typography>
                        <IconButton 
                            key="close" 
                            aria-label="close" 
                            style={{color:"white", float:"right"}}
                            onClick={onClose}>
                                <CloseIcon/>
                        </IconButton>
                    </PortletHeader>
                {isLoad ?
                    <PortletContent>
                        <Typography
                            variant="caption"
                        >
                            <CircularProgress
                            variant="indeterminate"
                            size={12}
                            thickness={3}
                        />
                            Cargando Información...
                        </Typography>
                    </PortletContent>
                :
                    <PortletContent style={{padding:'0px'}}>
                        {steps.map(step=>(
                            <ExpansionPanel key={step.id_paso}>
                        
                                <ExpansionPanelSummary
                                className={classes.backGrey}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id={step.id_paso}
                                > 
                                    <Typography variant="h4" className={classes.textWhite}>{step.nombre_paso}</Typography>
                                </ExpansionPanelSummary>
                                <Table>
                                        {this.dataElements(step.id_paso, step.nombre_paso, data)}
                                </Table>
                            </ExpansionPanel>
                        ))}
                    </PortletContent>}
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={modalOpen}
                        onClose={this.setCloseModal}
                        style={{
                            //maxHeight:'40vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 100,
                        }}               
                    >
                        <Fade in={modalOpen}>
                            <Audio data = {this.state}  onClose={this.setCloseModal}/>
                        </Fade>
                    </Modal>
            </Portlet> 
            
       
       
        ) 
    }
}



export default compose(withRouter, withStyles(styles))(AudioPatternElement);